import {Component, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {ModelFieldNumberComponent} from '../../../inputs/model-field/model-field-number/model-field-number.component';

@Component({
  selector: 'app-attribute-fulfillment-numeric',
  imports: [TranslocoPipe, ModelFieldNumberComponent],
  templateUrl: './attribute-fulfillment-numeric.component.html',
})
export class AttributeFulfillmentNumericComponent {
  readonly score = input.required<number | null>();
  readonly disabled = input.required<boolean>();
  readonly testIdKey = input.required<string>();

  readonly valueChange = output<number | undefined>();

  onValueChange(value: number | null): void {
    this.valueChange.emit(value ?? undefined);
  }
}
